module.exports = __webpack_public_path__ + "img/T5-B-xh3.c8a97b20.png";